<template lang="pug">
  .leads.white
    v-container.pa-0(style="max-width:600px")
      //- .sticky-header-container
        //- .sticky-header(:class="!showHeader ? 'hidden-header' : ''" )
      div.px-5
        div.mb-0(height="100px" flat outlined)
          //- v-row(no-gutters :class="!showHeader ? 'mt-3' : ''")
          div.text-center.mt-3
            div.h2.primary--text {{ totalCount }}
            div.h6.primary--text {{ $t('pending_orders') }}
          v-row.mt-1(no-gutters align="center")
            v-col.py-2.pr-2
              v-text-field(v-model="searchText" :placeholder="$t('search_order')" hide-details dense outlined height="40" background-color="basic200" @focus="searchBarExpand = true" @blur="checkSearch")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
            v-col.py-2.pr-2.shrink
              v-menu(bottom left offset-y)
                template(v-slot:activator='{ on }')
                  template(v-if="searchBarExpand")
                    v-btn.elevation-0.pa-0(color="transparent" small icon v-on='on')
                      eva-icon(name="settings-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
                  template(v-else)
                    v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light v-on='on')
                      eva-icon(name="settings-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
                      .label.primary400--text {{ $t('action') }}
                    //- v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light v-on='on')
                    //-   eva-icon(name="external-link" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
                    //-   .label.primary400--text Export
                v-list.pa-0
                  v-list-item(@click="startExport")
                    v-list-item-action-text.mr-2
                      v-img(:src="require('@/assets/images/icon_lalamove.png')" width="20px")
                    v-list-item-content
                      v-list-item-title
                        .s2.basic800--text| {{ $t('export_lalamove') }}
                  v-list-item(v-if="easyparcel_enabled" @click="startBulkShipping")
                    v-list-item-action-text.mr-2
                      v-img(:src="require('@/assets/images/logo_easyparcel_small.png')" width="20px")
                    v-list-item-content
                      v-list-item-title
                        .s2.basic800--text| {{ $t('bulk_shipping') }}
            v-col.py-1.shrink(v-if="woocommerce_enabled || shopify_enabled")
              template(v-if="searchBarExpand")
                v-btn.elevation-0.pa-0(color="transparent" small icon @click="clickOpenFilterSheet")
                  eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
              template(v-else)
                v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light @click="clickOpenFilterSheet")
                  eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
                  .label.primary400--text| {{ $t('filter') }}
            v-col.py-2.shrink(v-else)
              v-menu(bottom left offset-y)
                template(v-slot:activator='{ on }')
                  template(v-if="searchBarExpand")
                    v-btn.elevation-0.pa-0(color="transparent" small icon v-on='on')
                      v-icon(color="primary400" size="22") mdi-sort
                  template(v-else)
                    v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light v-on='on')
                      v-icon(small color="primary400" size="14" style="margin: 0 2px 0 4px") mdi-sort
                      .label.primary400--text {{ orderSort }}
                v-list(dense)
                  v-list-item(@click="clickSort('newest')")
                    v-list-item-title {{ $t('newest_to_oldest') }}
                  v-list-item(@click="clickSort('oldest')")
                    v-list-item-title {{ $t('oldest_to_newest') }}

    v-container.py-0(v-if="woocommerce_enabled || shopify_enabled" style="max-width: 600px;" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'px-5'")
      div.py-1.scrolling-wrapper(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
        span.mr-1
        v-chip.mx-1(color="basic600" outlined small) {{ $t('sort_by') }} :
          div.text-capitalize.ml-1 {{ orderSort }}
        v-chip.mx-1(v-if="orderSource !== 'All'" color="basic600" close outlined close-icon="mdi-close" small @click:close="orderSource = 'All'; fetchLeads(1)") {{ orderSource }}
        v-chip.mx-1(v-if="orderDeliveryDate !== 'All'" color="basic600" close outlined close-icon="mdi-close" small @click:close="orderDeliveryDate = 'All'; fetchLeads(1); deliveryDatePicker = null") {{ $t('delivery_date') }} : {{ orderDeliveryDate }}
        //- v-chip.mx-1(v-if="orderExtrafield !== 'All'" color="basic600" close outlined close-icon="mdi-close" small @click:close="orderExtrafield = 'All'; fetchLeads(1)") Extra Field : {{ orderExtrafield[1] }}
        span.ml-1
    v-container.px-2.pt-2(style="max-width: 600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6(v-if="leads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('no_orders_yet') }}
        v-container.px-0.pt-0.lighten-4(v-else)
          v-card.mb-4.mx-3.order-card.elevation-0(v-for="(lead, index) in leads" :key="lead.id")
            order-item.white.px-0(:parentLead.sync="lead" :index="index" @deleted="handleDeleteItem" :menu="menu" :zoneCount="zoneCount" :checkbox-active-export="activeExport" :checkbox-active-shipping="validForBulkShipping(lead)" @checkbox-updated="updateSelected($event)" @edited="handleEditItem")
      div.mx-3.mt-4
        y-pagination.mt-4.mb-6(v-model="page" :pageSize="fetchCount" :count="totalCount")
    v-footer.white.pa-0(v-if="activeExport" app inset fixed light)
      v-container.pa-0.px-4(style="max-width:600px")
        v-row(no-gutters align="center")
          v-col.py-2
            y-checkbox.ma-0.pa-0(v-model="selectAll" @change="checkSelect()" style="height:30px")
              template( v-slot:label )
                .s2.primary500--text {{ selectedLeads.length === 0 ? 'Select all orders' : selectedLeads.length + ' order' + (selectedLeads.length > 1 ? 's' : '') + ' selected' }}
          v-col.py-2.shrink
            v-btn.px-1.elevation-0(color="transparent" text height="40" @click="cancelExport")
              .button-Aa-medium.primary400--text| {{ $t('cancel') }}
          v-col.py-2.shrink
            v-btn.elevation-0(color="info500" @click="exportLalamove" height="40")
              .button-AA-medium.basic100--text| {{ $t('export') }}
    v-footer.white.pa-0(v-if="activeShipping" app inset fixed light)
      v-container.pa-0.px-4(style="max-width:600px")
        v-row(no-gutters align="center")
          v-col.py-2
            y-checkbox.ma-0.pa-0(v-model="selectAll" @change="checkSelectShipping()" style="height:30px")
              template( v-slot:label )
                .s2.primary500--text {{ selectedLeads.length === 0 ? 'Select all orders' : selectedLeads.length + ' order' + (selectedLeads.length > 1 ? 's' : '') + ' selected' }}
          v-col.py-2.shrink
            v-btn.px-1.elevation-0(color="transparent" text height="40" @click="cancelShipping")
              .button-Aa-medium.primary400--text| {{ $t('cancel') }}
          v-col.py-2.shrink
            v-btn.elevation-0(color="info500" @click="shipEasyparcel" height="40")
              .button-AA-medium.basic100--text| {{ $t('next') }}
    .filterSheet
      y-bottom-sheet(v-model='filterSheet' inset scrollable max-width="600px")
        v-card
          v-card-title.px-4
            div.h6.basic800--text {{ $t('filter_database') }}
            v-spacer
            v-btn(color="white" text @click="clearFilters")
              .button-Aa-small.primary400--text {{ $t('clear_filters') }}
            v-btn(color="textColorAccent" depressed height=32 dark @click="clickFilter")
              .button-AA-small.basic100--text {{ $t('filter') }}
          v-divider.basic300
          v-card-text.px-4.pb-8
            div.mt-4
              p.mb-2.label.basic600--text.text-uppercase {{ $t('sort_by') }}
              v-select(item-color="basic100" v-model="orderSortFilter" dense outlined height="40" background-color="basic200" :items="sortList" item-text="text" item-value="value" hide-details append-icon="mdi-chevron-down")
            div.mt-4
              p.mb-2.label.basic600--text.text-uppercase {{ $t('sales_channel') }}
              v-select(item-color="basic100"  v-model="orderSourceFilter" dense outlined height="40" background-color="basic200" :items="sourceList" hide-details append-icon="mdi-chevron-down")
            div.mt-4
              p.mb-2.label.basic600--text.text-uppercase {{ $t('delivery_date_extra_field') }}
              v-dialog(v-model="datePickerOpen" max-width="320px" persistent)
                template(v-slot:activator="{ on, attrs }")
                  v-text-field.mt-2(v-model="orderDeliveryDateFilter" dense solo flat outlined background-color="basic200" v-bind="attrs" v-on="on" append-icon="mdi-chevron-down" hide-details readonly type="button" style="text-align-last: left")
                v-date-picker(v-model="deliveryDatePicker" no-title)
                  v-spacer
                  v-btn(color="white" text @click="datePickerOpen = false; orderDeliveryDateFilter = 'All'; deliveryDatePicker = null")
                    .button-Aa-small.primary400--text {{ $t('cancel') }}
                  v-btn.mr-2(color="textColorAccent" depressed height=32 dark @click="pickDeliveryDate")
                    .button-AA-small.basic100--text OK
            //- div.mt-4
              p.mb-2.label.basic600--text.text-uppercase extra field
              v-combobox(v-model="orderExtrafieldFilter" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down" @click="openExtraFieldFilter = true" readonly type="button" style="text-align-last: left")
    .modal
      BulkShipItem(v-if="openBulkShipItemDialog" :open.sync="openBulkShipItemDialog" :parentLeads.sync="selectedLeads" @order-submitted="handleOrdersSubmitted")
      extra-field-filter(v-if="openExtraFieldFilter" :open.sync="openExtraFieldFilter" @selected="handleExtraFieldFilter")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import OrderItem from '@/components/OrderItem.vue'
import BulkShipItem from '@/components/dialogs/order/BulkShipItem.vue'
import ExtraFieldFilter from '@/components/dialogs/order/ExtraFieldFilter.vue'

export default {
  name: 'Orders',
  components: { OrderItem, BulkShipItem, ExtraFieldFilter },
  props: ['company', 'menu'],
  data (vm) {
    return {
      fullscreen: true,
      filterSheet:false,
      showHeader: true,
      lastScrollPosition: 0,
      isFetching: false,
      selectAll: false,
      selectAllByPage:[],
      fetchCount: 10,
      page: 1,
      totalCount: vm.$store.state.ui.pendingOrderCount,
      deliveredCount: 0,
      searchText: '',
      leads: [],
      searchCountDown: null,
      searchBarExpand: false,
      filters: [
        { text: 'All', value: '' },
        { text: 'Today', value: true },
        { text: 'Last Week', value: false }
      ],
      sortList: [
        { text: 'Newest to oldest', value: 'newest' },
        { text: 'Oldest to newest', value: 'oldest' }
      ],
      activeExport: null,
      selectedLeads: [],
      orderSource: 'All',
      orderSort: 'newest',
      orderExtrafield: 'All',
      orderDeliveryDate: 'All',
      orderSortFilter: '',
      orderSourceFilter: '',
      orderDeliveryDateFilter: '',
      orderExtrafieldFilter: '',
      openExtraFieldFilter: false,
      datePickerOpen: false,
      deliveryDatePicker: null,
      zoneCount: 0,
      activeShipping: null,
      openBulkShipItemDialog: false,
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    woocommerce_enabled () {
      return this.menu.woocommerce_enabled
      // return false
    },
    shopify_enabled () {
      return this.menu.shopify_enabled
      // return false
    },
    easyparcel_enabled () {
      return this.menu.easyparcel_enabled
      // return false
    },
    sourceList () {
      let list = ['All','Yezza']
      if (this.woocommerce_enabled) {
        list.push('WooCommerce')
      }
      if (this.shopify_enabled) {
        list.push('Shopify')
      }
      return list
    }
  },
  mounted () {
    this.fullscreen = window.innerWidth < 600
    this.fetchZones()
    if (!this.$route.query.page) {
      this.fetchLeads(1)
    } else {
      this.fetchLeads(this.$route.query.page)
    }
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    totalCount (val) {
      this.$store.commit('ui/setPendingOrderCount', val)
    },
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchLeads(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.fetchLeads(1)
      }, 500)
    },
    selectedLeads (val) {
      this.leads.forEach(lead => {
        this.$set(lead, 'checkboxSelected', val.map(m => m.id).includes(lead.id))
      })
    },
    leads (val) {
      if (this.activeExport || this.activeShipping) {
        val.forEach(lead => {
          this.$set(lead, 'checkboxSelected', this.selectedLeads.map(m => m.id).includes(lead.id))
        })
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLeads(page) {
      this.page = parseInt(page)
      this.isFetching = true
      if (this.selectAllByPage[this.page]==true) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
      let url = `/leads/?page=${page}&page_size=${this.fetchCount}&form__company=${this.company.id}&form_type_exclude=book_income`
      if (this.searchText && this.searchText.length >= 2 && this.searchText.includes('#')) {
        url += `&rid=${this.searchText.replace('#', '')}`
      } else if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      if (this.member.role !== 'Admin') {
        url += `&member=${this.member.id}`
      }
      if (this.orderSource !== 'All') {
        if (this.orderSource === 'Yezza') {
          url += `&form_type_exclude=woocommerce&form_type_exclude=shopify`
        } else if (this.orderSource === 'WooCommerce') {
          url += `&form_type=woocommerce`
        } else if (this.orderSource === 'Shopify') {
          url += `&form_type=shopify`
        }
      }
      if (this.orderDeliveryDate !== 'All') {
        url += `&extra_field=${this.orderDeliveryDate}`
      }
      if (this.orderExtrafield !== 'All') {
        url += `&extra_field=${this.orderExtrafield[1]}`
      }
      if (this.orderSort === 'newest') {
        url += `&ordering=-processed_at`
      } else if (this.orderSort === 'oldest') {
        url += `&ordering=processed_at`
      }
      url += `&status=processed`

      this.$axios.get(url)
      .then((response) => {
        this.isFetching = false
        this.leads = response.data.results
        this.totalCount = response.data.count
      })
      .catch(() => {})
    },
    fetchZones () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones`)
        .then((response) => {
          this.zoneCount = response.data.count
        })
        .catch(() => {})
    },
    clickOpenInvoice (invoice) {
      this.currentOpenInvoice = invoice
      this.openInvoiceDialog = true
    },
    clickOpenFilterSheet () {
      this.orderSortFilter = this.orderSort
      this.orderSourceFilter = this.orderSource
      this.orderDeliveryDateFilter = this.orderDeliveryDate
      this.orderExtrafieldFilter = this.orderExtrafield === 'All' ? 'All' : this.orderExtrafield[0].charAt(0).toUpperCase() + this.orderExtrafield[0].substr(1) + ' : ' + this.orderExtrafield[1]
      this.filterSheet = true
    },
    clickSort (val) {
      this.orderSort = val
      this.fetchLeads(1)
    },
    handleDeleteItem (item) {
      this.totalCount = this.totalCount - 1
      this.leads = this.leads.filter((x) => x.id !== item.id)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.leads.forEach((lead, index) => {
        if (lead.id === item.id) {
          editIndex = index
        }
      })
      this.leads = this.leads.filter((x) => x.id !== item.id)
      this.leads.splice(editIndex, 0, item)
    },
    handleExtraFieldFilter (evt) {
      if (evt.length > 0 ) {
        this.orderExtrafieldFilter = evt[0].charAt(0).toUpperCase() + evt[0].substr(1) + ' : ' + evt[1]
        this.orderExtrafield = [...evt]
      }
    },
    startExport () {
      this.cancelShipping()
      if (this.leads.length === 0) {
        this.showMessage(['error', this.$t('error_message.no_order_export')])
        return
      }
      if (!this.company.address) {
        this.showMessage(['error', this.$t('error_message.please_fill_company_address')])
        return
      }
      this.activeExport = 'lalamove'
    },
    cancelExport () {
      this.activeExport = null
      this.selectedLeads = []
      this.selectAll = false
    },
    handleOrdersSubmitted () {
      this.cancelShipping()
      this.fetchLeads(this.page)
    },
    updateSelected (checkbox) {
      const item = checkbox[1]
      item['shipping_status'] = 'pending'
      if (checkbox[0]) {
        this.selectedLeads.push(item)
      } else {
        this.selectedLeads = this.selectedLeads.filter((x) => x.id !== item.id)
      }
    },
    shippingSelectAll () {
      this.leads.forEach(lead => {
        if (!this.selectedLeads.includes(lead.id) && this.validForBulkShipping(lead)) {
          const item = lead
          item['shipping_status'] = 'pending'
          this.selectedLeads.push(item)
        }
      })
    },
    validForBulkShipping(lead) {
      if (this.activeShipping) {
        if (!lead.shipping) {
          return true
        } else if (['easyparcel', 'manual'].includes(lead.shipping.shipping_method) && (lead.shipping.status == 'new' || lead.shipping.status == 'error')) {
          return true
        }
      }
      return false
    },
    exportSelectAll () {
      this.leads.forEach(lead => {
        if (!this.selectedLeads.includes(lead.id)) {
          this.selectedLeads.push(lead)
        }
      })
    },
    exportDeselectAll () {
      this.leads.forEach(lead => {
        let index = this.selectedLeads.map(m => m.id).indexOf(lead.id)
        if (index !== -1) this.selectedLeads.splice(index, 1)
      })
    },
    exportLalamove () {
      if (this.selectedLeads.length === 0) {
        this.showMessage(['error', this.$t('error_message.select_one_order_export')])
        return
      }
      if (this.selectedLeads.length > 19) {
        this.showMessage(['error', this.$t('error_message.max_orders_in_export', { count: 19 })])
        return
      }

      let exportDomain = process.env.VUE_APP_BASE_URL
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
      .then(response => {
        const params = {
          company: this.company.id,
          provider: 'lalamove',
          leads: this.selectedLeads.map(m => m.id).join(','),
          key: response.data.key
        }
        this.cancelExport()
        const exportUrl = `${exportDomain}/shipping/shippings/export_fulfillment/?${queryString.stringify(params)}`
        if (this.$isMobile) {
          window.open(exportUrl)
        } else {
          location.href = exportUrl
        }
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.message) {
          this.showMessage(['error', e.response.data.message])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
      })
    },
    startBulkShipping () {
      this.cancelExport()
      this.activeShipping = 'easyparcel'
    },
    cancelShipping () {
      this.activeShipping = null
      this.selectedLeads = []
      this.selectAll = false
    },
    shipEasyparcel () {
      if (this.selectedLeads.length === 0) {
        this.showMessage(['error', this.$t('error_message.select_one_order_ship')])
        return
      }
      this.openBulkShipItemDialog = true
    },
    clearFilters () {
      this.orderSource = 'All'
      this.orderExtrafield = 'All'
      this.orderSort = 'newest'
      this.orderDeliveryDate = 'All'
      this.fetchLeads(1)
      this.filterSheet = false
    },
    clickFilter () {
      this.orderSort = this.orderSortFilter
      this.orderSource = this.orderSourceFilter
      this.orderDeliveryDate = this.orderDeliveryDateFilter
      this.fetchLeads(1)
      this.filterSheet = false
    },
    checkSelectShipping () {
      if (this.selectAll == true) {
        this.shippingSelectAll()
        this.selectAllByPage[this.page] = true
      } else {
        this.exportDeselectAll()
        this.selectAllByPage[this.page] = false
      }
    },
    checkSelect () {
      if (this.selectAll == true) {
        this.exportSelectAll()
        this.selectAllByPage[this.page] = true
      } else {
        this.exportDeselectAll()
        this.selectAllByPage[this.page] = false
      }
    },
    checkSearch () {
      if (!this.searchText) {
        this.searchBarExpand = false
      }
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    pickDeliveryDate () {
      this.orderDeliveryDateFilter = this.formatDate(this.deliveryDatePicker)
      this.datePickerOpen = false
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>

<style scoped>
.header-layout {
  position: relative;
}
.filter-layout{
  position: absolute;
  top: 18px;
  right: 8px;
}
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 100px;
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
    transform: translate3d(0, -70%, 0) !important;
  }
@media(min-width: 980px){
  .sticky-header.hidden-header{
    transform: translate3d(0, -60%, 0) !important;
  }
}
.order-card{
  border:1px solid var(--v-basic300);
  border-radius: 0;
  border-top:4px solid var(--v-primary200);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
}

/* custom v-select CSS */
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>

<i18n>
{
  "en": {
    "pending_orders": "Pending Orders",
    "export_lalamove": "Export Lalamove",
    "bulk_shipping": "Bulk shipping",
    "newest_to_oldest": "Newest to oldest",
    "oldest_to_newest": "Oldest to newest",
    "sort_by": "Sort by",
    "delivery_date": "Delivery date",
    "no_orders_yet": "No orders yet or empty",
    "filter_database": "Filter database",
    "clear_filters": "Clear filters",
    "sales_channel": "Sales channel",
    "delivery_date_extra_field": "delivery date ( extra field )"
  },
  "id": {
    "pending_orders": "Pesanan tertunda",
    "export_lalamove": "Expor Lalamove",
    "bulk_shipping": "Pengiriman Massal",
    "newest_to_oldest": "Terbaru ke terlama",
    "oldest_to_newest": "Terlama ke terbaru",
    "sort_by": "Susun mengikut",
    "delivery_date": "Tanggal pengiriman",
    "no_orders_yet": "Tiada pesanan",
    "filter_database": "Filter database",
    "clear_filters": "hapus filters",
    "sales_channel": "Sales channel",
    "delivery_date_extra_field": "Tanggal pengiriman ( extra field )"
  }
}
</i18n>
